import { StandardButton } from "../atoms/buttons"

export const TrueFalse = ({activeButton,activateButton}) => {
    const button1 = 1
    const button2 = 0
    return(
        <div className="horizontal true-false-bar">
                <StandardButton 
                    backgroundColor="unset"
                    textColor={"black"}
                    onClick={() => activateButton(button1)}
                    className={`true-false-comp ${(activeButton == button1)&&'active-true-false'}`} 
                    title={"waar"}/>
                <StandardButton 
                    backgroundColor="unset"
                    textColor={"black"}
                    onClick={() => activateButton(button2)}
                    className={`true-false-comp ${(activeButton == button2)&&'active-true-false'}`} 
                    title={"niet waar"}/>
        </div>
    )
}